<template>
    <a
        :href="ticker.link"
        @click.prevent="goToLink(tickerEvent.link)"
        class="flex items-center space-x-2.5 sm:rounded-lg px-3.5 py-2.5 text-left overflow-hidden shadow-sm border sm:max-w-md sm:w-full"
        :class="[tickerActive ? 'opacity-100' : 'opacity-25']"
        :style="{
            'background-color': ticker.colors.background,
            borderColor: ticker.colors.border,
        }"
    >
        <cUtilsEdit v-if="ticker.showIcon" @edit="goToEventField('tickerIcon', event.code)">
            <div
                :style="{
                    color: ticker.colors.cardText,
                    borderColor: ticker.colors.border,
                    'background-color': ticker.colors.cardBackground,
                }"
                class="flex-shrink-0 relative flex items-center justify-center h-10 w-10 rounded-lg overflow-hidden border"
            >
                <img v-if="tickerImage" :src="tickerImage" class="w-full h-full object-cover" />
                <component v-else :is="icon" class="h-5 w-5" />
            </div>
        </cUtilsEdit>

        <div>
            <cUtilsEdit @edit="goToEventField('tickerTitle', event.code)">
                <p
                    :style="{ color: ticker.colors.text }"
                    class="text-base font-medium"
                    v-html="tickerText"
                ></p>
            </cUtilsEdit>
            <div class="mt-0.5 text-sm font-regular opacity-80">
                <p
                    :style="{
                        color: ticker.colors.text,
                        'font-family': ticker.fontFamily,
                    }"
                >
                    {{ $t("ticker.event.few_seconds_ago") }} | {{ $t("ticker.event.verified_by") }}
                    <StripeLogoIcon class="h-5 inline align-bottom" />
                </p>
            </div>
        </div>
    </a>
</template>

<script>
import "flag-icons/css/flag-icons.min.css";
import { markRaw } from "vue";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";
import { StripeLogoIcon, TickerIcon } from "@easy/ui/icons";
import { useGoToLink } from "@/shared/utils/router/useGoToLink";
import { useTickerGoTo } from "@/views/tools/ticker/utils/useTickerGoTo";
import { tickersService } from "@/apps/ticker/services/tickers.service";

export default {
    components: {
        TickerIcon,
        StripeLogoIcon,
        cUtilsEdit,
    },
    setup() {
        const { goToLink } = useGoToLink();
        const { goToEventField } = useTickerGoTo();
        return {
            goToLink,
            goToEventField,
        };
    },
    props: {
        ticker: Object,
        event: Object,
    },
    data() {
        return {
            icons: tickersService.getIconsList(),
            exampleData: tickersService.getExampleData(),
        };
    },
    computed: {
        tickerEvent() {
            return this.ticker.events?.find((e) => e.code === this.event.code);
        },
        tickerActive() {
            return this.tickerEvent ? this.tickerEvent.active : false;
        },
        tickerText() {
            if (this.tickerEvent?.text) {
                let text = this.tickerEvent.text;
                const fields = ["product_name", "price", "customer_name", "city"];
                fields.forEach((field) => {
                    if (text.includes(`{${field}}`)) {
                        text = text.replace(`{${field}}`, this.exampleData[field]);
                    }
                });
                if (text.includes("{country_code}")) {
                    text = text.replace(
                        "{country_code}",
                        `<span class="inline-block fi fi-${this.exampleData.country_code.toLowerCase()}"></span>`
                    );
                }
                return text;
            }
            return this.event.example;
        },
        tickerImage() {
            return this.tickerEvent && this.tickerEvent.image ? this.tickerEvent.image : "";
        },
        tickerIcon() {
            return this.tickerEvent && this.tickerEvent.icon
                ? this.tickerEvent.icon
                : this.event.icon;
        },
        icon() {
            if (!this.tickerIcon) return markRaw(TickerIcon);
            return this.icons.find((i) => i.name === this.tickerIcon).icon;
        },
    },
};
</script>
